module.exports = {
	"config": {
		"siteTitle": "Zenthon",
		"siteDescr": "Zenthon's blog",
		"siteAuthor": "Zenthon",
		"twitterId": "",
		"googleAnalyticsId": "",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/zenthon/gatstrap/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/zenthon/gatstrap/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2015-05-01-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2015-05-01-hello-world",
				"stem": "index",
				"path": "articles/2015-05-01-hello-world/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2015-05-01-hello-world/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2015-05-01-hello-world/index.md",
			"path": "/articles/2015-05-01-hello-world/",
			"data": {
				"title": "The Birth of Movable Type",
				"date": "2016-03-01T22:12:03.284Z",
				"layout": "post",
				"category": "Typography TESTS",
				"description": "German inventor Johannes Gutenberg developed a method of movable type and used it to create one of the western world’s first major printed books, the “Forty–Two–Line” Bible.",
				"image": "Gutenberg.jpg"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-10-19-leveling-up-with-react-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-10-19-leveling-up-with-react-1",
				"stem": "index",
				"path": "articles/2016-10-19-leveling-up-with-react-1/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2016-10-19-leveling-up-with-react-1/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-10-19-leveling-up-with-react-1/index.md",
			"path": "/articles/2016-10-19-leveling-up-with-react-1/",
			"data": {
				"layout": "post",
				"title": "React开火三部曲之一:React Router",
				"date": "2016-10-19",
				"categories": [
					"react",
					"javascript"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-10-24-leveling-up-with-react-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-10-24-leveling-up-with-react-2",
				"stem": "index",
				"path": "articles/2016-10-24-leveling-up-with-react-2/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2016-10-24-leveling-up-with-react-2/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-10-24-leveling-up-with-react-2/index.md",
			"path": "/articles/2016-10-24-leveling-up-with-react-2/",
			"data": {
				"title": "React开火三部曲之二:容器组件",
				"layout": "post",
				"date": "2016-10-24",
				"categories": [
					"react",
					"javascript"
				],
				"image": "moby.svg"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-12-27-leveling-up-with-react-3",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-12-27-leveling-up-with-react-3",
				"stem": "index",
				"path": "articles/2016-12-27-leveling-up-with-react-3/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2016-12-27-leveling-up-with-react-3/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-12-27-leveling-up-with-react-3/index.md",
			"path": "/articles/2016-12-27-leveling-up-with-react-3/",
			"data": {
				"layout": "post",
				"title": "React开火三部曲之三:Redux!",
				"date": "2016-12-27",
				"categories": [
					"react",
					"redux",
					"javascript"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2016-12-29-my-2016",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2016-12-29-my-2016",
				"stem": "index",
				"path": "articles/2016-12-29-my-2016/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2016-12-29-my-2016/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2016-12-29-my-2016/index.md",
			"path": "/articles/2016-12-29-my-2016/",
			"data": {
				"layout": "post",
				"title": "我的2016",
				"description": "",
				"date": "2016-12-29",
				"categories": [
					"扯淡"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-11-deploy-create-react-app-with-nginx",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-11-deploy-create-react-app-with-nginx",
				"stem": "index",
				"path": "articles/2017-03-11-deploy-create-react-app-with-nginx/index.md",
				"absolute": "/Users/zenthon/gatstrap/articles/2017-03-11-deploy-create-react-app-with-nginx/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2017-03-11-deploy-create-react-app-with-nginx/index.md",
			"path": "/articles/2017-03-11-deploy-create-react-app-with-nginx/",
			"data": {
				"layout": "post",
				"title": "Deploy create-react-app(react-router) with nginx",
				"description": "",
				"date": "2017-03-11",
				"categories": [
					"nginx",
					"react"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/zenthon/gatstrap/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/profile",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/profile",
				"stem": "index",
				"path": "pages/profile/index.md",
				"absolute": "/Users/zenthon/gatstrap/pages/profile/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/profile/index.md",
			"path": "/profile/",
			"data": {
				"id": 1380,
				"title": "Profile",
				"date": "2016-05-15T17:48:12.000Z",
				"author": "jaxx2104",
				"layout": "page",
				"path": "/profile",
				"guid": "http://jaxx2104.info/?page_id=1380",
				"image": "/wp/images/2014/12/b0edb59d97976fb1c698b9997460f6e3-e1458137465824.jpg"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0